(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxClassDeleteController',TaxClassDeleteController);

    TaxClassDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxClass'];

    function TaxClassDeleteController($uibModalInstance, entity, TaxClass) {
        var vm = this;
        vm.taxClass = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TaxClass.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
